<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";

//Custom  Components
import UserService from "@/helpers/APIService/user.service";
import { authComputed } from "@/state/helpers";
import errorHandler from "@/helpers/errorHandler";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
      policyTypeOption: [
        { text: "Wifi Portal", value: "wifi_portal", disabled: false },
        { text: "Kiosk Portal", value: "kiosk_portal", disabled: false },
        { text: "Lock Portal", value: "lock_portal", disabled: false },
        { text: "Guest Portal", value: "guest_portal", disabled: false },
        { text: "Checkin Portal", value: "checkin_portal", disabled: false },
      ],
      terms: {
        booking_source: [],
        policy_type: "wifi",
        internal_name: null,
        title_text: null,
        detail_html_text: null,
        is_publish: false,
        is_deleted: true,
      },
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessages: null,
      isSaveAndAddNew: false,
    };
  },
  validations: {
    terms: {
      internal_name: {
        required,
      },
      title_text: {
        required,
      },
      detail_html_text: {
        required,
      },
    },
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  computed: {
    ...authComputed,
  },
  mounted() {
    this.editTerm();
  },
  methods: {
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        const bookingSourceId = [];
        this.terms.booking_source.map((item) => {
          bookingSourceId.push(item.id);
        });
        const data = {
          hotel: this.hotel.id,
          booking_source: bookingSourceId,
          policy_type: this.terms.policy_type,
          internal_name: this.terms.internal_name,
          title_text: this.terms.title_text,
          detail_html_text: this.terms.detail_html_text,
          is_publish: this.terms.is_publish,
        };
        if (!this.currentProps.editData) {
          UserService.createTerms(data).then(
            (terms) => {
              if (!this.isSaveAndAddNew) {
                this.$emit("submitted", terms);
              } else {
                this.$emit("saveAndAddNew", terms);
                this.terms = {
                  booking_source: [],
                  internal_name: null,
                  title_text: null,
                  is_publish: false,
                };
              }
              this.isBtnLoading = false;
              this.submitted = false;
            },
            (error) => {
              errorHandler(error);
              this.isBtnLoading = false;
            }
          );
        } else {
          UserService.editTerms(data, this.currentProps.editData.id).then(
            (terms) => {
              this.$emit("submitted", { by: "edit", terms });
              this.isBtnLoading = false;
              this.submitted = false;
            },
            (error) => {
              errorHandler(error);
              this.isBtnLoading = false;
            }
          );
        }
      }
    },
    editTerm() {
      if (this.currentProps.edit) {
        setTimeout(() => {
          this.terms.detail_html_text =
            this.currentProps.editData.detail_html_text;
        }, 100);
        this.terms.policy_type = this.currentProps.editData.policy_type;
        this.terms.booking_source = this.currentProps.editData.booking_source;
        this.terms.internal_name = this.currentProps.editData.internal_name;
        this.terms.title_text = this.currentProps.editData.title_text;
        this.terms.is_publish = this.currentProps.editData.is_publish;
        this.terms.is_deleted = this.currentProps.editData.is_deleted;
      }
    },
    // Method is use to save and add new guest continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    // Method is used to cancel add new guest
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
  },
};
</script>

<template>
  <div class="offcanvas-body text-black">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-8">
            <div class="mb-3">
              <label for="internal_name"
                >Internal Name <span class="text-danger">*</span> </label
              ><span
                ><i
                  class="fa fa-info-circle text-muted ml-1"
                  data-bs-container="#tooltip-container"
                  tabindex="0"
                  data-plugin="tippy"
                  data-tippy-arrow="true"
                  data-tippy-animation="fade"
                  v-b-popover.hover="
                    'Internal name will not display to guest. It is for internal use only.'
                  "
                ></i
              ></span>

              <input
                type="text"
                autocomplete="off"
                class="form-control"
                id="internal_name"
                name="internal_name"
                :disabled="!terms.is_deleted"
                placeholder="Internal name"
                v-model="terms.internal_name"
                :class="{
                  'is-invalid': submitted && $v.terms.internal_name.$error,
                }"
              />
              <div
                v-if="submitted && $v.terms.internal_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.terms.internal_name.required"
                  >Term internal name is required.</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <b-form-group
              class="mb-3 form-label"
              label="Policy Type"
              label-for="policy_type"
            >
              <b-form-select
                class="form-select"
                id="policy_type"
                type="text"
                autocomplete="off"
                :options="policyTypeOption"
                v-model="terms.policy_type"
              >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <label for="title_text"
                >Terms And Condition Title Text
                <span class="text-danger">*</span>
                <i
                  class="fa fa-info-circle text-muted ms-1"
                  data-bs-container="#tooltip-container"
                  tabindex="0"
                  data-plugin="tippy"
                  data-tippy-arrow="true"
                  data-tippy-animation="fade"
                  v-b-popover.hover="
                    'Internal name will not display to guest. It is for internal use only.'
                  "
                ></i
              ></label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                id="title_text"
                name="title_text"
                :disabled="!terms.is_deleted"
                placeholder="Terms And Condition Title"
                v-model="terms.title_text"
                :class="{
                  'is-invalid': submitted && $v.terms.title_text.$error,
                }"
              />
              <div
                v-if="submitted && $v.terms.title_text.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.terms.title_text.required"
                  >Term title text is required.</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <label for="Detailhtmltext">
                <span slot="label"
                  >Detail HTML Text <span class="text-danger">*</span></span
                >
                <i
                  class="fa fa-info-circle text-muted ms-1"
                  data-bs-container="#tooltip-container"
                  tabindex="0"
                  data-plugin="tippy"
                  data-tippy-arrow="true"
                  data-tippy-animation="fade"
                  v-b-popover.hover="
                    `Write your terms and condition here and it's convert into HTML.`
                  "
                ></i>
              </label>
              <tinymce
                id="d1"
                v-model="terms.detail_html_text"
                :plugins="plugins"
                :toolbar="toolbar"
                :other_options="options"
                :class="{
                  'is-invalid': submitted && $v.terms.detail_html_text.$error,
                }"
              ></tinymce>
              <div
                v-if="submitted && $v.terms.detail_html_text.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.terms.detail_html_text.required"
                  >Detail html text is required.</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="mb-3">
              <label for="title_text"
                >Select Booking Source
                <span class="text-danger">*</span>
              </label>
              <b-button-group class="float-end">
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="terms.booking_source = currentProps.bookingSources"
                  >Attach All</b-button
                >
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="terms.booking_source = []"
                  >Detach All</b-button
                >
              </b-button-group>
              <multiselect
                v-model="terms.booking_source"
                track-by="name"
                label="name"
                class="mt-2"
                placeholder="Select Booking Sources"
                :options="currentProps.bookingSources"
                :multiple="true"
                :taggable="true"
                :show-labels="false"
              >
                <template slot="singleLabel" slot-scope="{ option }"
                  ><strong> {{ option.name }}</strong></template
                >
              </multiselect>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-check form-switch form-switch-md mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="SwitchCheckSizemd"
                v-model="terms.is_publish"
              />
              <label class="form-check-label" for="SwitchCheckSizemd"
                >Is Publish</label
              >
            </div>
          </div>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel
            </b-button>
            <b-button
              v-if="currentProps.edit === false"
              class="float-end ms-2"
              variant="outline-primary"
              type="submit"
              @click="saveAndAddNew"
              :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
            >
              <i
                v-if="isSaveAndAddNew === true && isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i
              >Save & Add
            </b-button>
            <b-button
              class="float-end"
              variant="outline-primary"
              @click="onSubmit"
              :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
            >
              <i
                v-if="isSaveAndAddNew !== true && isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              {{ currentProps.edit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
